const MerchantServicesAddServicePrice = (props) => {
  return <h1>Add Service - Price</h1>;
};

export default MerchantServicesAddServicePrice;
